import type { RouteConfig } from 'react-router-config'
import { Order } from '@yy/one-icon'
import { withAsync } from '@/components/Async'
import { withAuthRedirect } from '@common/oneclub/components/Authorization/withAuthRedirect'
import Blank from '@/layouts/Blank'

const routes: RouteConfig[] = [
  {
    alias: 'bill_management',
    path: '/billManagement',
    component: withAuthRedirect(Blank, {}),
    menuTitle: 'codBill.billManagement',
    icon: Order,
    // permission: 'bills',
    routes: [
      // COD账单管理
      {
        alias: 'cod_bill_management',
        path: '/codBill',
        permission: ['OS:bills:codBill'],
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/CodBill')),
        menuTitle: 'codBill.codBillManagement',
        exact: true,
      },
      {
        path: '/codBill/detail',
        permission: ['OS:bills:codBill'],
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/CodBill/Detail')),
        exact: true,
      },
      {
        alias: 'freight_bill_management',
        path: '/freight-bill',
        permission: { or: ['OS:bills:freightBill', 'OW:bills:freightBill'] },
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/FreightBill')),
        menuTitle: 'bill.page.title',
        exact: true,
      },
      {
        alias: 'freight_bill_detail_management',
        path: '/freight-bill/:system/:id',
        permission: { or: ['OS:bills:freightBill', 'OW:bills:freightBill'] },
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/FreightBillDetail')),
        hideMenu: true,
      },
      {
        path: '/owBill',
        permission: ['OW:bills:owFreightBill'],
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/OwBill')),
        menuTitle: 'bill.title.ow',
        exact: true,
      },
      {
        path: '/summaryBill',
        permission: { or: ['OS:bills:summaryBill', 'OW:bills:summaryBill'] },
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/SummaryBill')),
        menuTitle: 'bill.title.summaryBill',
        exact: true,
      },
      {
        path: '/summaryBill/:id',
        permission: { or: ['OS:bills:summaryBill', 'OW:bills:summaryBill'] },
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/SummaryBill/detail')),
        exact: true,
      },
      {
        path: '/freightSummaryBill',
        permission: { or: ['OS:bills:summaryFreight', 'OW:bills:summaryFreight'] },
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/FreightSummaryBill')),
        menuTitle: 'bill.title.freightSummaryBill',
        exact: true,
      },
      {
        path: '/freightSummaryBill/:id',
        permission: { or: ['OS:bills:summaryFreight', 'OW:bills:summaryFreight'] },
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/FreightSummaryBill/Detail')),
        exact: true,
      },
      {
        path: '/payBill',
        permission: { or: ['OS:bills:summaryBill', 'OW:bills:summaryBill'] },
        component: withAsync(() => import(/* webpackChunkName: "BillManagement" */ '@/containers/admin/BillManagement/PayBill')),
        menuTitle: 'bill.pay.menuTitle',
        exact: true,
      },
    ],
  },
]

export default routes
